var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "New Trash",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.149 11.8273L11.6919 4.47493H11.9112C12.238 4.47493 12.5164 4.22253 12.5164 3.86972C12.5164 3.54128 12.2396 3.26452 11.9112 3.26452H10.7125L9.88678 1.80378C9.64821 1.446 9.21998 1.20825 8.76735 1.20825H5.94043C5.48778 1.20825 5.05949 1.44609 4.82093 1.80389L3.9953 3.26452H2.79661C2.44381 3.26452 2.19141 3.54289 2.19141 3.86972C2.19141 4.22095 2.44539 4.47493 2.79661 4.47493H2.99308L3.53596 11.8265L3.53603 11.8273C3.60701 12.6318 4.24708 13.2249 5.05247 13.2249H9.63255C10.4379 13.2249 11.078 12.6318 11.149 11.8273ZM8.87469 2.47757L9.24972 3.26452H5.45806L5.82606 2.48884C5.8591 2.41867 5.9011 2.41867 5.94043 2.41867H8.76735C8.81126 2.41867 8.84868 2.41867 8.87469 2.47757ZM4.74595 11.748L4.20386 4.47493H10.4812L9.93907 11.748C9.9194 11.8996 9.78574 12.0145 9.63255 12.0145H5.05247C4.89929 12.0145 4.76562 11.8996 4.74595 11.748Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.14a20701f5b89cafa48a918c4eb98f8e.svg";
export { ForwardRef as ReactComponent };